import { createContext } from "react";

const ActivitiMasterDataContext = createContext({});

export default ActivitiMasterDataContext;
